import { Box, Flex, Heading, LinkBox, LinkOverlay, ListItem } from "@chakra-ui/react";

import styled from "@emotion/styled";
import Image from "next/image";
import React from "react";


const getUrlFromSlug = (result: any) => {

  const directory = result?.parentPageSlug || 'blog'
  if (typeof result["page_type"] === "undefined") {
    return `${process.env.NEXT_PUBLIC_SITE_URL}${directory}/${result?.slug}`;
  }
  if (result["page_type"] === "pageBlogPost" || result["page_type"] === "post") {
    return `${process.env.NEXT_PUBLIC_SITE_URL}${directory}/${result?.slug}`;
  }

  return `${process.env.NEXT_PUBLIC_SITE_URL}${result?.slug}`;
};

const ImageContainer = styled.div`
  width: 100%;

  > div,
  span {
    position: unset !important;
  }

  img {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }
`;

export type IResult = {

    objectID?: string;
    title?: string;
    slug?: string;
    excerpt?: string;
    description?: string;
    date_created?: string;
    cover_image?: string;
    author_name?: string;
    author_picture?: string;

  }

export type ISearchResult = {
  result: IResult;
  onCloseModal: () => void;
  index: number;
};

const SearchResult: React.FC<ISearchResult> = ({result, index, onCloseModal}) => {


  const date = new Date(result?.date_created || new Date().toString());

  const localeDateString = date.toLocaleString();
  return (
    <ListItem key={result?.objectID} m={"0 1em 1em 1em"}>
      <LinkBox bg="#fff" borderRadius={15}>
        <Flex
          direction={["column", "column", "row"]}
          justifyContent="center"
          alignItems="center"
          gap={2}
          p={5}
        >
          <Box
            h={["200px", "200px", "100%"]}
            w={["100%", "100%", "40%"]}
            borderRadius="15px"
            style={{
              borderRadius: "15px",
              overflow: "hidden",
            }}
          >
            <ImageContainer>
              {result?.cover_image ? (
                <Image
                  src={`https:${result?.cover_image}`}
                  fill
                  alt={result?.title || ""}
                />
              ) : (
                <span />
              )}
            </ImageContainer>
          </Box>
          <Box p={5} w={["100%", "100%", "60%"]}>
              <LinkOverlay href={getUrlFromSlug(result)} onClick={onCloseModal}>
                <Heading as="h3" size="lg" mb={2}>
                  {result?.title}
                </Heading>
              </LinkOverlay>
            <Flex
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              gap={2}
              mb={3}
            >
              <Flex
                direction="row"
                justifyContent="center"
                alignItems="center"
                gap={2}
              >
                {result?.author_picture ? (
                  <Image
                    src={`https:${result?.author_picture}`}
                    width={25}
                    height={25}
                    alt={`Picture of ${result?.author_name}`}
                  />
                ) : (
                  <span />
                )}
                {result?.author_name}
              </Flex>
              <div>{localeDateString}</div>
            </Flex>

            <Box pt={5}>{result?.excerpt || result?.description}</Box>
          </Box>
        </Flex>
      </LinkBox>
    </ListItem>
  );
};

export default React.memo(SearchResult);
